export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7359.fb975370.jpg";